module.exports = __webpack_public_path__ + "img/details-list-dropdown.3082d265.svg";